export default "__VITE_ASSET__XT6NjOlq__"